import { ChangeEvent, FormEvent, useState } from 'react'

import Button from '../../../components/button/Button'
import TextField from '../../../components/text-field/TextField'
import { OnboardingStepProps } from '../types'
import {
  StepBody,
  StepFooter,
  ErrorBanner,
  InlineFieldRow,
  Spacer,
} from '../styled'

/**
 * Step 1: capture firstName + lastName.
 *
 * @param {OnboardingStepProps} props
 * @returns {JSX.Element}
 */
const NameStep = ({
  profile,
  onSubmit,
  onBack,
  isSubmitting,
}: OnboardingStepProps): JSX.Element => {
  const [firstName, setFirstName] = useState<string>(profile?.firstName ?? '')
  const [lastName, setLastName] = useState<string>(profile?.lastName ?? '')
  const [errorMessage, setErrorMessage] = useState<string>('')

  const handleFirstNameChange = (
    event: ChangeEvent<HTMLInputElement>,
  ): void => {
    setFirstName(event.target.value)
  }

  const handleLastNameChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLastName(event.target.value)
  }

  const handleSubmit = async (
    event: FormEvent<HTMLFormElement>,
  ): Promise<void> => {
    event.preventDefault()
    setErrorMessage('')

    if (firstName.trim() === '') {
      setErrorMessage('Tell us your first name.')
      return
    }

    if (lastName.trim() === '') {
      setErrorMessage('And your last name.')
      return
    }

    await onSubmit({
      firstName: firstName.trim(),
      lastName: lastName.trim(),
    })
  }

  return (
    <form onSubmit={handleSubmit}>
      <StepBody>
        <InlineFieldRow>
          <TextField
            label="First name"
            value={firstName}
            onChange={handleFirstNameChange}
            placeholder="e.g. Avery"
            autoComplete="given-name"
            autoFocus
          />
          <TextField
            label="Last name"
            value={lastName}
            onChange={handleLastNameChange}
            placeholder="e.g. Singh"
            autoComplete="family-name"
          />
        </InlineFieldRow>
        {errorMessage !== '' ? <ErrorBanner>{errorMessage}</ErrorBanner> : null}
      </StepBody>
      <StepFooter>
        {onBack === null ? (
          <Spacer />
        ) : (
          <Button type="button" variant="ghost" onClick={onBack}>
            ← Back
          </Button>
        )}
        <Button type="submit" isLoading={isSubmitting}>
          Continue
        </Button>
      </StepFooter>
    </form>
  )
}

export default NameStep
